import { render, staticRenderFns } from "./notificationSpace.vue?vue&type=template&id=444d9e77&"
import script from "./notificationSpaceControl.js?vue&type=script&lang=js&"
export * from "./notificationSpaceControl.js?vue&type=script&lang=js&"
import style0 from "./notificationSpace.css?vue&type=style&index=0&lang=css&"
import style1 from "./notificationSpace720.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports